import { render, staticRenderFns } from "./EmployerBankSettingsForm.vue?vue&type=template&id=92c42f3e&scoped=true"
import script from "./EmployerBankSettingsForm.vue?vue&type=script&lang=ts"
export * from "./EmployerBankSettingsForm.vue?vue&type=script&lang=ts"
import style0 from "./EmployerBankSettingsForm.vue?vue&type=style&index=0&id=92c42f3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c42f3e",
  null
  
)

export default component.exports